import React, { useEffect, useState } from "react";
import { useEducation } from "../../../hooks/useEducation";
import ClassCard from "./ClassCard";
import hearts from "../../../assets/new-education/Hearts.svg";
import "./MyFavorites.css";

const FavoriteCard = () => {
  return (
    <div
      className="favorite-card"
      style={{
        backgroundColor: "#C4A68C",
        opacity: 0.8,
        color: "white",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "160px",
        height: "209px",
      }}
    >
      <h3 style={{ margin: "0 0 10px 0", fontSize: "18px" }}>Favorite</h3>
      <img src={hearts} alt="Heart" width={88.5} height={98} />
    </div>
  );
};

const MyFavorites = () => {
  const {
    myCourses,
    myCoursesLoading,
    myCoursesError,
    fetchMyCourses,
    favoriteClasses,
    favoriteClassesLoading,
    favoriteClassesError,
    fetchFavoriteClasses,
  } = useEducation();

  const [favoriteCourses, setFavoriteCourses] = useState([]);
  const [favoriteClassesData, setFavoriteClassesData] = useState([]);

  useEffect(() => {
    fetchMyCourses();
    fetchFavoriteClasses();
  }, [fetchMyCourses, fetchFavoriteClasses]);

  useEffect(() => {
    if (myCourses.length > 0) {
      // Process favorite courses
      const favoriteCoursesData = myCourses.filter(
        (course) => course.is_favorite
      );

      const favoriteCoursesAsClasses = favoriteCoursesData.map(
        (favoriteCourse) => ({
          id: favoriteCourse.id,
          name: favoriteCourse.course_name,
          courseId: favoriteCourse.course,
          enrollmentId: favoriteCourse.id,
          is_course: true,
          course_name: favoriteCourse.course_name,
          category_name: favoriteCourse.category_name,
          thumbnail: favoriteCourse.thumbnail,
          progress_percentage: favoriteCourse.progress_percentage,
          duration: favoriteCourse.duration,
          class_count: favoriteCourse.class_count,
          completed_class_count: favoriteCourse.completed_class_count,
          is_favorite: favoriteCourse.is_favorite,
        })
      );

      setFavoriteCourses(favoriteCoursesAsClasses);
    }
  }, [myCourses]);

  useEffect(() => {
    if (favoriteClasses.length > 0 && myCourses.length > 0) {
      const processedFavoriteClasses = favoriteClasses.map((classProgress) => {
        const courseEnrollment = myCourses.find(
          (course) => course.id === classProgress.my_course
        );

        return {
          id: classProgress.edu_class,
          name: classProgress.class_name || `Class ${classProgress.edu_class}`,
          courseId: courseEnrollment?.course || null,
          enrollmentId: classProgress.my_course,
          is_course: false,
          progress: classProgress,
          course_name: courseEnrollment?.course_name || "Unknown Course",
          category_name: courseEnrollment?.category_name || "Unknown Category",
          thumbnail: courseEnrollment?.thumbnail || null,
          status: classProgress.status,
          last_accessed: classProgress.last_accessed,
          completed_at: classProgress.completed_at,
          is_favorite: classProgress.is_favorite,
        };
      });

      setFavoriteClassesData(processedFavoriteClasses);
    }
  }, [favoriteClasses, myCourses]);

  if (myCoursesLoading || favoriteClassesLoading) {
    return <div className="loading-container">Loading your courses...</div>;
  }

  if (myCoursesError || favoriteClassesError) {
    return (
      <div className="error-container">
        Error loading courses: {myCoursesError || favoriteClassesError}
      </div>
    );
  }

  if (myCourses.length === 0) {
    return (
      <div className="empty-courses-container">
        <h2>You haven't enrolled in any courses yet</h2>
        <p>
          Explore our course catalog to find something you're interested in!
        </p>
      </div>
    );
  }

  const allFavorites = [...favoriteCourses, ...favoriteClassesData];

  return (
    <div className="my-favorites-container">
      <div className="courses-layout">
        <div className="course-list-container">
          <ul className="course-list">
            <li className="course-item">
              <FavoriteCard />
            </li>
          </ul>
        </div>

        <div className="course-classes-container">
          <div className="favorite-classes-list">
            {allFavorites.length === 0 ? (
              <div className="no-classes">
                <p>No favorite courses or classes found</p>
                <p>Mark courses or classes as favorites to see them here!</p>
              </div>
            ) : (
              <div className="classes-grid">
                {allFavorites.map((item) => (
                  <ClassCard
                    key={
                      item.is_course
                        ? `course-${item.enrollmentId}`
                        : `class-${item.id}`
                    }
                    classItem={item}
                    courseId={item.courseId}
                    enrollmentId={item.enrollmentId}
                    is_course={item.is_course}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyFavorites;
